import _sliceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/slice";
import _Array$from from "@babel/runtime-corejs3/core-js/array/from";
import _Symbol from "@babel/runtime-corejs3/core-js/symbol";
import _getIteratorMethod from "@babel/runtime-corejs3/core-js/get-iterator-method";
function _createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof _Symbol !== "undefined" && _getIteratorMethod(o) || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { var _context; if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = _sliceInstanceProperty(_context = Object.prototype.toString.call(o)).call(_context, 8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return _Array$from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
/**
 * @brief find the router instance
 *
 * in React, find the history of router
 * for react-router@5, we need get the history from providers
 * as it use the new context api of React
 *
 * in Vue, find the $router
 */
import { useInstance, createRef, onMounted } from 'intact-vue';
import { isExternalLink } from '../components/utils';
export function useRouter() {
  var instance = useInstance();
  var ref = createRef();
  onMounted(function () {
    ref.value = findRouter(instance);
  });
  return ref;
}
export function navigate(router, to) {
  if (to) {
    if (router && !isExternalLink(to)) {
      router.push(to);
    } else {
      location.href = to;
    }
  }
}
function findRouter(instance) {
  var Component = instance.constructor;
  if (Component.$cid === 'IntactReact') {
    // in React
    var parent = instance;
    while (!parent.$isReact) {
      parent = parent.$senior;
      if (!parent) return;
    }
    for (var _iterator = _createForOfIteratorHelperLoose(parent.$reactProviders), _step; !(_step = _iterator()).done;) {
      var _step$value = _step.value,
        key = _step$value[0],
        value = _step$value[1];
      var displayName = key._context.displayName;
      // V6
      if (displayName === 'Navigation') {
        return value.navigator;
      }
      // V5
      if (displayName === 'Router') {
        return value.history;
      }
    }
  } else if (Component.$cid === 'IntactVue') {
    do {
      var _parent = instance.$parent;
      if (_parent) {
        return _parent.$router;
      }
    } while (instance = instance.$senior);
  } else if (Component.$cid === 'IntactVueNext') {
    // for vue-next
    do {
      var vueInstance = instance.vueInstance;
      if (vueInstance) {
        return vueInstance.proxy.$router;
      }
    } while (instance = instance.$senior);
  }
}